import config from "./config"
import { Stroke, Style } from "ol/style";
import Fill from "ol/style/Fill";

export const isVdm = () =>{
    return window.location.pathname.search(config.urlville)!==-1;
}

export const getGeoJSON=(listedonnees)=> {

    var geojson = {
        "type": "FeatureCollection",
        "crs": {"type": "name", "properties": {"name": "EPSG:3857"}},
        "features": [
        ]
    };

    for (var i in listedonnees) {
        var ligne = {"type": "Feature", "properties": {}, "geometry": {}};
        for(var cle in listedonnees[i]){
            var valeur = listedonnees[i][cle]
            if (cle === "geom") {
                ligne.geometry = JSON.parse(valeur);
            } else {
                ligne.properties[cle] = valeur;
            }
        };
        geojson.features.push(ligne);
    }
    return geojson;
}

export function masquerCarre(element, nomCouleur){
    element.getSource().forEachFeature(pol=>{if(pol.getProperties().couleur === nomCouleur){
        pol.setStyle(
               new Style({
                stroke: new Stroke({
                      color: "#00000000"
                    }),
                    fill: new Fill({
                        color: "#00000000"
                    })
                 })
           )
    }})
}

export function afficherCarre(element, nomCouleur, couleurStroke, couleurFill){
    element.getSource().forEachFeature(pol=>{if(pol.getProperties().couleur === nomCouleur){
        const type = pol.getProperties().type;
        pol.setStyle(
            new Style({
                stroke: new Stroke({
                    width: type === "angle" ? 5 : 1,
                    color: couleurStroke
                }),
                fill: new Fill({
                    color: couleurFill
                })
            })
        )
    }})
}